import { SORT } from "./action";

const initState = {
  products: [],
};
// console.log(initState.products);

export const productReducer = (store = initState, { type, payload }) => {
  switch (type) {
    case SORT:
      return {
        ...store,
        products: [...store.products].sort((a, b) => a[payload] - b[payload]),
      };

    default:
      return store;
  }
};
